// Updated App.js - manually apply theme to body only
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { Analytics } from "@vercel/analytics/react";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import ProjectDetail from "./pages/ProjectDetail";
import Photography from "./pages/Photography";
import PhotographySeries from "./pages/PhotographySeries";
import About from "./pages/About";
import "./App.css";

function App() {
  useEffect(() => {
    // Apply theme colors directly to body element
    // This way Tailwind classes like bg-black stay black
    document.body.style.backgroundColor = "var(--color-background)";
    document.body.style.color = "var(--color-text)";
  }, []);

  return (
    <Router>
      {/* DON'T use bg-black here - let body handle it */}
      <div className="min-h-screen">
        <Navbar />
        <Routes>
          <Route path="/" element={<About />} />
          <Route path="/work" element={<Home />} />
          <Route path="/project/:id" element={<ProjectDetail />} />
          <Route path="/photography" element={<Photography />} />
          <Route
            path="/photography/:seriesId"
            element={<PhotographySeries />}
          />
          <Route path="/about" element={<Navigate to="/" replace />} />
        </Routes>
        <Analytics />
      </div>
    </Router>
  );
}

export default App;
